import React, { useState } from 'react';
import '../../pages/Project/ProjectPage.css'
import { Link } from 'react-router-dom';
import { ButtomGet } from '../ButtomGet/ButtomGet';

/* Multi idioma */
import { FormattedMessage } from 'react-intl';

/* Swiper */
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import { Pagination, Autoplay, EffectCoverflow } from "swiper";

const handleClick = () => {
  alert('Contact developer');
};

/* Img */
const proyectImg = require.context('../../img', true);

const Project = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="proyectos" id="proyectos">
      <div className="projects-header" data-aos="fade-down" data-aos-duration="800">
        <h2 className="heading">
          <FormattedMessage
            id='projects'
            defaultMessage='Projects'
          />
        </h2>
        <p className="projects-subtitle">
          <FormattedMessage
            id='projects-subtitle'
            defaultMessage='A showcase of my recent work and development projects'
          />
        </p>
      </div>
      
      <div className="proyect-site" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
        <Swiper
          spaceBetween={30}
          loop={true}
          grabCursor={true}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          effect={'coverflow'}
          coverflowEffect={{
            rotate: 20,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          modules={[Pagination, Autoplay, EffectCoverflow]}
          breakpoints={{
            0: {
              slidesPerView: 1,
              coverflowEffect: {
                rotate: 10,
                stretch: 0,
                depth: 50,
                modifier: 1,
                slideShadows: false,
              }
            },
            768: {
              slidesPerView: 2,
              coverflowEffect: {
                rotate: 15,
                stretch: 0,
                depth: 75,
                modifier: 1,
                slideShadows: true,
              }
            },
            1024: {
              slidesPerView: 3,
              coverflowEffect: {
                rotate: 20,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }
            },
          }}
          className='proyectos-slider mySwiper'
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        >
          <SwiperSlide className='caja'>
            <div className="project-card">
              <div className="project-image">
                <img
                  src={proyectImg(`./proyecto-13.png`)}
                  alt='Blook Vault Project'
                />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href="https://book-vault-frontend-bay.vercel.app/" className="demo-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-eye"></i>
                    </a>
                    <a href="https://arunchy07.github.io/Book_vault_frontend" className="code-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-code"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="content">
                <h3>Blook Vault</h3>
                <p>
                  This Book Recommendation System 
                </p>
                <div className="tecnologias">
                  <span>React</span>
                  <span>TailwindCSS</span>
                  <span>FastAPI</span>
                  <span>MongoDB</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide className='caja'>
            <div className="project-card">
              <div className="project-image">
                <img
                  src={proyectImg(`./proyecto-11.png`)}
                  alt='EduManage Project'
                />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href="https://school-directory-ten.vercel.app/" className="demo-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-eye"></i>
                    </a>
                    <a href="https://github.com/Arunchy07/school-directory" className="code-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-code"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="content">
                <h3>EduManage</h3>
                <p>
                  All School Manage Application 
                </p>
                <div className="tecnologias">
                  <span>Next.js</span>
                  <span>Tailwind CSS</span>
                  <span>TypeScript</span>
                  <span>MySQL</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide className='caja'>
            <div className="project-card">
              <div className="project-image">
                <img
                  src={proyectImg(`./proyecto-10.png`)}
                  alt='Incredible India Travels Project'
                />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href="https://incredible-india-travels.vercel.app/" className="demo-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-eye"></i>
                    </a>
                    <a onClick={handleClick} className="code-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-code"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="content">
                <h3>Incredible India Travels</h3>
                <p>
                  Plan, book, and manage your trips effortlessly with our travel app—smart itineraries.
                </p>
                <div className="tecnologias">
                  <span>Django</span>
                  <span>HTML</span>
                  <span>Bootstrap 5</span>
                  <span>MongoDB</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide className='caja'>
            <div className="project-card">
              <div className="project-image">
                <img
                  src={proyectImg(`./proyecto-14.png`)}
                  alt='Fix Tool Project'
                />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href="https://dictionary-sigma-eight.vercel.app/" className="demo-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-eye"></i>
                    </a>
                    <a href="https://github.com/Arunchy07" className="code-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-code"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="content">
                <h3>VocabMate</h3>
                <p>
                  Dictionary for Search word Meaning
                </p>
                <div className="tecnologias">
                  <span>React</span>
                  <span>CSS</span>
                  <span>FastAPI</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide className='caja'>
            <div className="project-card">
              <div className="project-image">
                <img
                  src={proyectImg(`./proyecto-12.png`)}
                  alt='BuyOro Project'
                />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href="https://68aa8da85f3d2e1feedd7227--buyoro.netlify.app/" className="demo-link" target="_blank" rel="noopener">
                      <i className="fas fa-eye"></i>
                    </a>
                    <a onClick={handleClick} className="code-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-code"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="content">
                <h3>BuyOro</h3>
                <p>
                  E-Commerce Web Application
                </p>
                <div className="tecnologias">
                  <span>React</span>
                  <span>Django</span>
                  <span>MongoDB</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      
      <div className='portafolio-btn' data-aos="fade-up" data-aos-delay="500">
        <Link to="/project">
          <ButtomGet/>
        </Link>
      </div>
    </section>
  );
};
export default React.memo(Project);